import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { LoadingActions } from 'actions'

export default class WaitListActions extends Actions{
    static get target(){
        return 'waitLists'
    }

    static fetch(data){
        LoadingActions.append({waitLists: true})
        if(store.getState().session.accountID){
            this.client.organizations.waitLists.fetch({
                organizationID: store.getState().config.organizationID,
                accountID: store.getState().session.accountID
            }).then(({data})=>{
                const values = data.reduce((acc,item)=>{
                    acc[item.id] = item
                    return acc
                },{})
    
                this.set(values)
                
                LoadingActions.append({waitLists: false})
            })
        } else {
            LoadingActions.append({waitLists: false})
        }
    }

    static create(data){
        return this.client.organizations.waitLists.create(data).then((response)=>{
            return response
        })
    }

    static destroy(data){
        return this.client.organizations.waitLists.destroy({
            organizationID: store.getState().config.organizationID,
            id: data.id
        }).then((response)=>{
            return response
        })
    }
}


// WEBPACK FOOTER //
// ./actions/WaitListActions.js